import { render, staticRenderFns } from "./school-information.vue?vue&type=template&id=3851067e"
import script from "./school-information.vue?vue&type=script&lang=js"
export * from "./school-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports